import {PageFragment, PageFragmentProps, PageFragmentState, PageFragmentStyleFlags} from "@/shared/PageFragment";
import {LabelerTask, LabelerTasks, ResourceData} from "@/fyneai-shared/types";
import {TabInfo} from "@/shared/TabsContainer";
import React from "react";
import {TaskOverviewFragment} from "./TaskOverviewFragment";
import {TaskLabelsFragment} from "./TaskLabelsFragment";
import {TaskImportsFragment} from "../imports/ImportsFragment";
import {TaskCasesFragment} from "./TaskCasesFragment";

export type TaskFragmentProps = PageFragmentProps & {
  datasetId: string,
  taskId: string,
  onBack: () => void,
}

type TaskFragmentState = PageFragmentState & {
  task: LabelerTask,
}

enum TabType {
  OVERVIEW = "overview",
  IMPORTS = "imports",
  CASES = "cases",
  LABELS = "labels",
  ANALYSIS = "analysis",
}

const TABS: TabInfo<TabType>[] = [
  {text: "Overview", type: TabType.OVERVIEW},
  {text: "Imports", type: TabType.IMPORTS},
  {text: "Cases", type: TabType.CASES},
  {text: "Labels", type: TabType.LABELS},
  {text: "Analysis", type: TabType.ANALYSIS},
];

export class TaskFragment extends PageFragment<TaskFragmentProps, TaskFragmentState> {

  protected onCreateState(props?: TaskFragmentProps): TaskFragmentState {
    return {
      ...super.onCreateState(props),
      selectedToolbarTabId: TabType.OVERVIEW,
    };
  }

  protected getTitle(): string | null | undefined {
    return "Title";
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    await super.fetchOnMount(forceReload);
    const task = await new LabelerTasks(ResourceData.projectId(), this.props.datasetId).getOrLoadItem(this.props.taskId);
    this.setState({
      task,
      title: task.name,
    });
  }

  getToolbarTabs(): TabInfo<any>[] {
    return TABS;
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_BACK_BUTTON_FLAG | PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  onBackButtonClicked() {
    this.props.onBack();
  }

  renderContent(): React.ReactElement {
    switch (this.state.selectedToolbarTabId) {
      case TabType.OVERVIEW:
        return <TaskOverviewFragment path={this.props.path} task={this.state.task}/>;
      case TabType.IMPORTS:
        return <TaskImportsFragment path={this.props.path} datasetId={this.props.datasetId} task={this.state.task}/>;
      case TabType.CASES:
        return <TaskCasesFragment path={this.props.path} task={this.state.task}/>;
      case TabType.LABELS:
        return <TaskLabelsFragment path={this.props.path} task={this.state.task}/>;
      case TabType.ANALYSIS:
      default:
        return null;
    }
  }
}